import { render, staticRenderFns } from "./UniversalRing.vue?vue&type=template&id=682e3884&scoped=true"
import script from "./UniversalRing.vue?vue&type=script&lang=js"
export * from "./UniversalRing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682e3884",
  null
  
)

export default component.exports